(ns machtfit.product-form.inhibit
  (:require [re-frame.core :as rf]))

(defn set-save-inhibitor [current-db inhibitor]
  (update-in current-db [:ui :save-inhibitors] #(if (nil? %)
                                                  #{inhibitor}
                                                  (conj % inhibitor))))

(defn unset-save-inhibitor [current-db inhibitor]
  (update-in
   current-db
   [:ui :save-inhibitors]
   #(disj % inhibitor)))

(defn inhibited? [inhibitor inhibitors]
  (cond
    (contains? inhibitors :all) true
    (= :all inhibitor) (not (empty? inhibitors))
    :else (contains? inhibitors inhibitor)))

(rf/reg-sub ::inhibited?
  :<- [:get [:ui :save-inhibitors]]

  (fn [inhibitors [_ inhibitor]]
    (inhibited? inhibitor inhibitors)))
